import jobsMutations from "./mutations.js";
import jobsActions from "./actions.js";
import jobsGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            allJobsStatusList: [],
            jobsPanelState: false
        };
    },
    mutations: jobsMutations,
    actions: jobsActions,
    getters: jobsGetters,
};